import CreateInvestmentError from './CreateInvestmentError';
class CouponAlreadyExpired extends CreateInvestmentError {
    constructor(options) {
        super('Coupon is already expired', options);
    }
}
export default CouponAlreadyExpired;
